import { useState } from "react"
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX"
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _CreditAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../contract/select/SelectMonths";

export const ActualizarCarteraDatos = () => {

    const instance = useDataBean(_CreditAccount);
    const [data, setData] = useState<any>('');
    const [correo, setCorreo] = useState<string>(_single.getAccount().eMail);
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());

    const loadData = () => {

        instance.instance.recrearCreditoFromFile(_single.getAccountID(), JSON.stringify(data)).then(
            (resp: any) => {
                toast.success("Se inicio proceso de actualizacion");
            }
        )
    }
    const updateLoan = () => {
        instance.instance.executeRutine(_single.getAccountID(), "UPDATE_LOAN", [correo]).then(
            (resp: any) => {
                toast.success("Tarea en ejecución");
            }
        )
    }

    const updateCuote = () => {
        instance.instance.executeRutine(_single.getAccountID(), "UPDATE_LOAN_CUOTE", [correo]).then(
            (resp: any) => {
                toast.success("Tarea en ejecución");
            }
        )
    }
    const updateManagedCreditByFile = () => {
        instance.instance.updateManagedCreditByFile(_single.getAccountID(), year, month, JSON.stringify(data)).then(
            (resp: any) => {
                toast.success("Tarea en ejecución");
            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Notificar</label>
                <input type="text" className="form-control" value={correo} onChange={(e) => { setCorreo(e.target.value) }} />
            </div>
            <div className="col-md-3">
                <YearSelector tittle="Año" value={year} onChange={(e) => { setYear(e) }} />
            </div>
            <div className="col-md-3">
                <SelectMonths label="Mes" idSelector={month} onChange={(e) => { setMonth(e) }} />
            </div>
            <div className="col-md-6">
                <ImportXLSX lodaData={setData} />

            </div>
            <div className="col-md-12">
                <BasicButton disable={correo == ''} icon="" eventClick={updateLoan} useMargin>Actualizar Lineas</BasicButton>
                <BasicButton disable={correo == ''} icon="" eventClick={updateCuote} useMargin>Actualizar Cuota</BasicButton>
                <BasicButton disable={correo == ''} icon="" eventClick={updateManagedCreditByFile} useMargin>Actualizar Administrados</BasicButton>
                <BasicButton icon="" useMargin eventClick={loadData}>Actualizar</BasicButton>
            </div>
        </div>
    )
}